import request from "src/api/request-manager/gateway";

const prefixURL = "/dashboard/v1";

const UsersAPI = {
  getUsers() {
    return request.get(`${prefixURL}/users`);
  },
  logoutUser(headers: Record<string, any> = {}) {
    return request.post(`${prefixURL}/user/logout`, {}, headers);
  }
};

export default UsersAPI;
